import { AdminLogin } from '@/components/AdminLogin';

export const AdminLoginPage = () => {
  return <AdminLogin />;
};
